module.exports = __webpack_public_path__ + "img/delivery (1).ac0294a8.png";